// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"52bfe2fc","241":"506a22ba"}[chunkId] + ".chunk.js";
};